import { apiURL, callAPI } from 'api/main';

interface ISendInviteParams {
  userId: number;
  message: string;
  dates: string[];
}

export default async (params: ISendInviteParams): Promise<boolean> => {
  try {
    const res = await callAPI({
      url: `${apiURL}/v3/sys/match/prospection/invite`,
      method: 'POST',
      needToken: true,
      params,
    });

    const { success } = res.request;

    if (success) {
      return success;
    }

    return false;
  } catch (ex) {
    return false;
  }
};
